// @flow
import { StaffProfilesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    perfil: {},
    listaPerfiles: [],
    loading: false,
    loadingList: false,
    error: false,
    errorList: false,
    formSubmited: false
};

type StaffProfilesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { perfil?: {} | null, listaPerfiles?: [] | null, loading?: boolean, +value ?: boolean };

const StaffProfiles = (state: State = INIT_STATE, action: StaffProfilesAction): any => {
    // console.log(action);
    switch (action.type) {
        case StaffProfilesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {

                case StaffProfilesActionTypes.LIST_STAFF_PROFILES: {
                    return {
                        ...state,
                        listaPerfiles: action.payload.data,
                        errorList: false,
                        loadingList: false,
                        formSubmited: false
                    };
                }

                default:
                    return { ...state };
            }

        case StaffProfilesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {

                case StaffProfilesActionTypes.LIST_STAFF_PROFILES: {
                    return {
                        ...state,
                        errorList: true,
                        listaPerfiles: [],
                        loadingList: false,
                        formSubmited: false
                    };
                }

                default:
                    return { ...state };
            }


        case StaffProfilesActionTypes.LIST_STAFF_PROFILES:
            return { ...state, errorList: false, loadingList: true };

        case StaffProfilesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                loadingList: false,
                errorList: false,
                perfil: {},
                listaPerfiles: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default StaffProfiles;
